var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-icon"},[_c('FontAwesomeIcon',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.click.focus.blur.top",value:(_vm.helpText),expression:"helpText",modifiers:{"hover":true,"click":true,"focus":true,"blur":true,"top":true}}],attrs:{"icon":_vm.helpIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }